import vaccum from "../../../assets/Services_img/vaccum.jpg";

export const vacuumInertGasService = {
  hero: {
    title: "Vacuum & Inert Gas System ",
    description:
      "Ensuring reliable vacuum stability and ultra-high purity inert gas flow for critical glovebox operations.",
      title2:"Servicing",
      imgUrl:vaccum
  },

  productsDetails: {
    imgList: [
      vaccum
    ],

    productName: "Vacuum & Inert Gas System Servicing",

    description:
      "This service focuses on maintaining the core atmospheric control systems of your glovebox. Our engineers service vacuum pumps, inspect gas supply lines, verify regulator performance, and optimize purge cycles to ensure stable pressure control and contamination-free inert environments.",

    keyFeatures: [
      "Vacuum pump inspection, servicing, and oil replacement",
      "Leak testing of gas supply lines and fittings",
      "Pressure regulator and valve performance verification",
      "Purge cycle optimization and system tuning",
      "Verification of inert gas purity and flow stability",
    ],

    download: {
      title: "Download Service Overview PDF",
      downloadLink: "",
    },

    reviewList: [],
    descriptionTitle:"Service Description",

    briefDescirption:
      "A stable vacuum and high-purity inert gas supply are critical for maintaining glovebox performance. This service minimizes contamination risks, improves system efficiency, and ensures consistent atmospheric control for research and industrial applications.",
  },
};
